'use client';
import { ReactNode } from 'react';
import { CategoryProvider } from '@/shared/ui/providers/category-provider';
import { SubCategoriesContext, SubCategoriesProvider } from '@/shared/ui/providers/subcategories-provider';
import { SubCategoriesData } from './types';

type Props = {
    children?: ReactNode;
} & Omit<SubCategoriesData, 'data'>;

export const SubCategoriesFor = ({ children, filters, ...props }: Props) => {
    return (
        <SubCategoriesProvider filters={filters ?? {}} {...props}>
            <SubCategoriesContext.Consumer>
                {({ data }) =>
                    data.map((category) => (
                        <CategoryProvider key={category.id} value={{ data: category }}>
                            {children}
                        </CategoryProvider>
                    ))
                }
            </SubCategoriesContext.Consumer>
        </SubCategoriesProvider>
    );
};
